import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'Components/Modal';
import Icon from 'Components/Icon';
import EnvironmentManager from 'Utils/environmentManager';

const ErrorModal = ({
  isOpen,
  onClose,
  message
}) => {
  if (!isOpen) return null;

  return (
    <Modal
      isOpen={ true }
      onClose={ onClose }
      position={ { web: 'center' } }
      className="fast-deposit-modal"
    >
      <div className="fast-deposit-error">
        <button
          type="button"
          className="fast-deposit-error__close"
          onClick={ onClose }
        >
          <Icon iconName="svgFastDepositClose" />
        </button>
        <div className="fast-deposit-error__icon">
          <Icon iconName="svgErrorModal" />
        </div>
        <h3 className="fast-deposit-error__title">{ EnvironmentManager.getMainMessageText({ key: 'fast_deposit_page_error_title' }) }</h3>
        <p className="fast-deposit-error__message">{ message }</p>
      </div>
    </Modal>
  );
};

ErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string
};

export default ErrorModal;
